// Un solo Marcador (/webphone) por navegador. La extensión admite 1 contacto SIP (max_contacts=1, gana el primero):
// una segunda ventana que intente registrar se queda en "Conectando". Dos capas:
//  1) openOrFocusWebphone: al pulsar "Marcador" se reutiliza la ventana existente (nombre fijo) y se enfoca.
//  2) claimSingleWebphone: dentro de /webphone, un candado (Web Locks) impide que una segunda ventana registre.
// Un navegador no puede maximizar ni desminimizar una ventana por su cuenta: lo máximo posible es enfocarla.

export const WEBPHONE_WINDOW = 'pbx-webphone';
const LOCK_NAME = 'pbx-webphone-instance';
const CHANNEL_NAME = 'pbx-webphone';

// Abre el Marcador o, si ya existe en este navegador, lo trae al frente SIN recargarlo (recargar perdería el registro
// o la llamada en curso). Debe llamarse dentro de un clic para que no lo bloquee el navegador. Devuelve null si lo bloquea.
export function openOrFocusWebphone(win = window) {
  let w;
  try { w = win.open('', WEBPHONE_WINDOW); } catch { return null; }
  if (!w) return null;
  let yaAbierto = false;
  try { yaAbierto = w.location.pathname === '/webphone'; } catch { /* otro origen o ilegible: se redirige */ }
  if (!yaAbierto) { try { w.location.href = '/webphone'; } catch { /* sin acceso */ } }
  try { w.focus(); } catch { /* el navegador puede negar el foco */ }
  return w;
}

// Reclama ser la ÚNICA ventana del Marcador. role 'primary' = puede registrar; 'duplicate' = ya hay otra (esta no
// debe registrar y le pide a la primera ponerse al frente). Sin Web Locks no se puede garantizar: no se bloquea a nadie.
export function claimSingleWebphone({ locks, makeChannel, onFocusRequest } = {}) {
  const channel = makeChannel ? makeChannel(CHANNEL_NAME) : null;
  const cerrar = () => { try { channel && channel.close(); } catch { /* ya cerrado */ } };
  if (!locks) return Promise.resolve({ role: 'primary', release: cerrar });

  return new Promise((resolve) => {
    locks.request(LOCK_NAME, { ifAvailable: true }, (lock) => {
      if (!lock) {
        channel && channel.postMessage({ type: 'focus' });
        resolve({ role: 'duplicate', release: cerrar });
        return undefined;
      }
      if (channel) channel.onmessage = (e) => { if (e.data && e.data.type === 'focus' && onFocusRequest) onFocusRequest(); };
      // El candado se retiene mientras esta promesa esté pendiente: se libera con release() o al cerrar la pestaña.
      return new Promise((liberar) => { resolve({ role: 'primary', release: () => { cerrar(); liberar(); } }); });
    });
  });
}
